import React from 'react';
import loadable from '@loadable/component';
const CombineOrderListComponent = loadable(
  () => import('../components/CombineOrder/CombineOrderList')
);

const CombineOrderList = () => {
  return (
    <>
      <CombineOrderListComponent />
    </>
  );
};

export default CombineOrderList;
